import "$styles/index.css";
import "$styles/syntax-highlighting.css";

import "./quick_search.js";
import "./highlight_anchor.js";

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}";

// import "@fontsource-variable/readex-pro"
// import "@fontsource-variable/fira-code"

console.info("Bridgetown is loaded!");
